import styled from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';

export const SimilarSpaceSection = styled.div`
  padding: 0 0 20px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
  margin-bottom: 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    border-radius: 0;
    margin-bottom: 0;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    &:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

export const SimilarAgencyAdsContent = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding-top: 10px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    padding-top: 20px;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    padding: 20px 0 0;
  }
`;
